export default __webpack_public_path__ + "static/media/email.4043826b.svg";